import styled from "styled-components";

export const InputStyled = styled.input`
      padding: 10px;
      border: 1px solid #ddd;
`;